import React from 'react'
import { Button, Typography, Paper } from "@material-ui/core";
import { useRouter } from "@contexts/RouterProvider";
import styles from "@styles/showPage";
import withStyles from "@material-ui/core/styles/withStyles";

const ReportsMenu = ({ classes }) => {
  const router = useRouter();

  return (
    <Paper
      className={classes.showPage__wrapper}
      elevation={0}
    >
      <header className={classes.showPage__header}>
        <Typography component="h2" variant="h5">
          {I18n.t("activerecord.models.v4/reports.other")}
        </Typography>
      </header>
      <main className={classes.showPage__value}>
        <Button
          className={classes.showPage__value}
          onClick={() => router.visit("admin/reports/climate", { spa: true })}
          key={1}
          variant="outlined"
          color="primary"
          fullWidth
        >
          {I18n.t("activerecord.models.v4/reports.climate")}
        </Button>
        <Button
          className={classes.showPage__value}
          onClick={() => router.visit("admin/reports/irrigation", { spa: true })}
          key={1}
          variant="outlined"
          color="primary"
          fullWidth
        >
          {I18n.t("activerecord.models.v4/reports.irrigation")}
        </Button>
        <Button
          className={classes.showPage__value}
          onClick={() => router.visit("admin/reports/ndvi", { spa: true })}
          key={1}
          variant="outlined"
          color="primary"
          fullWidth
        >
          {I18n.t("activerecord.models.v4/reports.ndvi")}
        </Button>
      </main>
    </Paper>
  );
}

export default withStyles(styles)(ReportsMenu);
